@if (isProcessingLogin()) {
  <loader [backdrop]="true" [loadingText]="'Loggar in...'"></loader>
}

<div class="m-0">
  <div class="login-page">
    @if (domain() =='svf'){
      <iframe src="https://internt.svenskafonster.se/kundportalen-startsida" class="iframe" allowtransparency="true" frameborder="0" scrolling="no" allowfullscreen></iframe>
    } @else if (domain() =='mf') {
      <iframe src="https://mockfjards.se/" class="iframe d-none d-lg-block" allowtransparency="true" frameborder="0" scrolling="auto" allowfullscreen></iframe>
    }

    <div class="login">
      <div class="login-header">
        @if (domain() == 'svf') {
          <img loading="lazy" class="img-fluid" src="assets/images/SvF_RGB_neg.svg">
        }
      </div>
      <div class="me-3">
        @if(domain() =='mf') {
          <img loading="lazy" class="img-fluid" style="margin-top:20px;" src="assets/images/Mockfjards_logo_CMYK_liggande_offwhite_CMYK.svg">
        }

        @if(inactiveMessageArr()?.length) {
          <div class="alert alert-warning alert-dismissible fade show" role="alert">
            @if(inactiveMessageArr().length > 1) {
              <strong>{{inactiveMessageArr()[0]}}</strong>
              <hr class="m-0">
              <small class="fw-light"><i>Senast aktiv {{inactiveMessageArr()[1]}}</i></small>
            } @else {
              <strong>{{inactiveMessageArr()[0]}}</strong>
            }
            <button type="button" class="btn-close float-end" data-bs-dismiss="alert" aria-label="Close" (click)="clearLogoutMessage()"></button>
          </div>
        }

        <h1>Kundportalen</h1><br />

        <form class="mb-2" name="loginForm" id="loginForm" autocomplete="on" (ngSubmit)="login()">

          <p-floatlabel variant="on">
            <input id="username" pInputText name="username" autofocus autocomplete="on" class="mt-0 form-control" type="text" [ngModel]="username()" (ngModelChange)="username.set($event)" (keyup.enter)="onKeyEnter()" />
            @if (domain() === 'svf') {
              <label class="text-sm" for="username"><i class="me-2 fa-xs fa-regular fa-user"></i>Användarnamn</label>
            }
          </p-floatlabel>

          @if (!passwordReset()) {
            <p-floatlabel variant="on">
              <input id="password" pInputText name="password" autocomplete="on" class="mt-0 form-control" type="password" [ngModel]="password()" (ngModelChange)="password.set($event)" (keyup.enter)="onKeyEnter()" />
              @if (domain() === 'svf' && !passwordReset()) {
                <label class="text-sm" for="password"><i class="me-2 fa-xs fa-regular fa-key"></i>Lösenord</label>
              }
            </p-floatlabel>

            <button type="submit" class="btn btn-success btn-rounded">Logga in <i class="ms-2 fa-regular fa-arrow-right-to-arc"></i></button>
          }
        </form>

        @if (passwordReset()) {
          <button class="btn btn-rounded btn-success mb-3" (click)="doPasswordReset()">Återställ lösenord <i class="ms-2 fa-regular fa-rotate-left"></i></button>
        }

        @if (errorMessage() !== undefined) {
          <div class="alert alert-warning" role="alert">{{errorMessage()}}</div>
        }

        <br />

        @if (passwordReset()) {
          <div class="footer">
            <a class="link-hover" (click)="togglePasswordReset()">Tillbaka till inloggning</a>
          </div>
        } @else {
          <div class="text-white">
            Har du glömt lösenordet? <a class="link-hover" (click)="togglePasswordReset()">Återställ </a>
          </div>
        }
        <br>
        @if (infoMessagePasswordReset() !== undefined) {
          <div class="info-message">{{infoMessagePasswordReset()}}</div>
        }

        @if (errorMessagePasswordReset() !== undefined) {
          <div class="error-message alert-warning">{{errorMessagePasswordReset()}}</div>
        }
      </div>
      <div class="footer">
        Behöver du hjälp? <a class="link-hover" (click)="openModalContactSupport()">Kontakta support</a>
      </div>
    </div>
  </div>
</div>

<ng-template #contactSupportTemplate>
  <contact-support [modalId]="contactSupportModalId"></contact-support>
</ng-template>
